import React, { FC, useEffect, useState } from "react";
import { useAccessibility } from "../../providers/accessibility-hooks";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { TopBar } from "./TopBar";

export interface HeaderProps {
  rightElement: React.ReactElement;
}

export const Header: FC<HeaderProps> = (props) => {
  const { accessibility } = useAccessibility();

  const logoPeSrc = "/assets/img/logo/logo-pe-origin.png";
  const logoPeForHighContrastSrc =
    "/assets/img/logo/logo-pe-origin-contrast.png";

  const [logoSrc, setLogoSrc] = useState(logoPeSrc);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down(768));
  const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down(425));

  useEffect(() => {
    if (accessibility?.contrast === "high") {
      setLogoSrc(logoPeForHighContrastSrc);
    } else {
      setLogoSrc(logoPeSrc);
    }
  }, [accessibility?.contrast]);

  return (
    <header className="xvia-header-area">
      <TopBar />
      <div className="xvia-header-spacing xvia-container">
        <div className="xvia-header-logo">
          <a href="/">
            <img
              className="xvia-header-logo-img"
              src={logoSrc}
              alt="Logo de Pernambuco"
              width={!isSmallScreen ? 180 : isExtraSmallScreen ? 120 : 140}
            />
          </a>
        </div>
        <div className="xvia-header-elements">{props.rightElement}</div>
      </div>
    </header>
  );
};
